// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.metaTag-container {
  padding: 24px;
}
.metaTag-header {
  font-size: 2rem;
  font-weight: 600;
  font-family: Poppins;
}
.metaTag-header-container {
  display: flex;
  justify-content: space-between;
  padding-bottom: 30px;
}

.btn-flex {
  display: flex;
  gap: 30px;
}

.input {
  width: 25%;
}

.btn-group {
  padding-top: 30px;
  display: flex;
  gap: 30px;
  padding-bottom: 30px;
}
.seoContentsList {
  display: flex;
  justify-content: space-between;
}

.quest-header {
  margin-right: 0px;
}

.answer {
  font-family: "Roboto", "Helvetica", "Arial", sans-serif;
  font-weight: 700;
  font-size: 0.875rem;
  margin-top: 25px;
  display: grid;
  grid-template-columns: 150px 500px 50px 50px;
  column-gap: 10px;
}

.category-card-wrapper {
  display: grid;
  grid-template-columns: repeat(3, 1fr); /* 4 per row */
  gap: 10px;
}
.category-card-container-application {
  width: 90%; /* card takes full column */
}

/* 50-50 layout */
.row-50-50 {
  display: flex;
  gap: 20px;
  align-items: center;
  justify-content: space-between;
}

.row-50-50 .col {
  flex: 1 1;
}

.row-50-50 .text {
  flex: 1 1; /* 50% */
}

.row-50-50 .image {
  flex: 1 1; /* 50% */
  display: flex;
  justify-content: center;
  align-items: center;
}

.row-50-50 .image img {
  max-width: 100%;
  height: auto;
  border-radius: 6px;
}

.sun-editor .se-dialog .se-dialog-inner .se-dialog-form .se-input-form {
  padding: 4px 4px !important;
}
`, "",{"version":3,"sources":["webpack://./src/features/MetaTagsAndSeo/metatagseo.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,SAAS;EACT,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,uDAAuD;EACvD,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,4CAA4C;EAC5C,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qCAAqC,EAAE,cAAc;EACrD,SAAS;AACX;AACA;EACE,UAAU,EAAE,2BAA2B;AACzC;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,SAAO,EAAE,QAAQ;AACnB;;AAEA;EACE,SAAO,EAAE,QAAQ;EACjB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;AAC7B","sourcesContent":[".metaTag-container {\n  padding: 24px;\n}\n.metaTag-header {\n  font-size: 2rem;\n  font-weight: 600;\n  font-family: Poppins;\n}\n.metaTag-header-container {\n  display: flex;\n  justify-content: space-between;\n  padding-bottom: 30px;\n}\n\n.btn-flex {\n  display: flex;\n  gap: 30px;\n}\n\n.input {\n  width: 25%;\n}\n\n.btn-group {\n  padding-top: 30px;\n  display: flex;\n  gap: 30px;\n  padding-bottom: 30px;\n}\n.seoContentsList {\n  display: flex;\n  justify-content: space-between;\n}\n\n.quest-header {\n  margin-right: 0px;\n}\n\n.answer {\n  font-family: \"Roboto\", \"Helvetica\", \"Arial\", sans-serif;\n  font-weight: 700;\n  font-size: 0.875rem;\n  margin-top: 25px;\n  display: grid;\n  grid-template-columns: 150px 500px 50px 50px;\n  column-gap: 10px;\n}\n\n.category-card-wrapper {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr); /* 4 per row */\n  gap: 10px;\n}\n.category-card-container-application {\n  width: 90%; /* card takes full column */\n}\n\n/* 50-50 layout */\n.row-50-50 {\n  display: flex;\n  gap: 20px;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.row-50-50 .col {\n  flex: 1;\n}\n\n.row-50-50 .text {\n  flex: 1; /* 50% */\n}\n\n.row-50-50 .image {\n  flex: 1; /* 50% */\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.row-50-50 .image img {\n  max-width: 100%;\n  height: auto;\n  border-radius: 6px;\n}\n\n.sun-editor .se-dialog .se-dialog-inner .se-dialog-form .se-input-form {\n  padding: 4px 4px !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
